export interface ChatWorkProductScope {
    workProductId: string | null;
    workProductTitle: string | null;
    workProductLevel: string | null;
    workProductContentType: string | null;
    workProductPhase: string | null;
    editorSurface: "ide" | "rich-text" | null;
    featureId: string | number | null;
    featureName: string | null;
    userStoryId: string | null;
    userStoryTitle: string | null;
}

export function normalizeActiveWorkProductForChat(
    effectiveWorkProductForChat: Partial<ChatWorkProductScope> | null | undefined
): ChatWorkProductScope | null {
    if (!effectiveWorkProductForChat) return null;
    return {
        workProductId: effectiveWorkProductForChat.workProductId ?? null,
        workProductTitle: effectiveWorkProductForChat.workProductTitle ?? null,
        workProductLevel: effectiveWorkProductForChat.workProductLevel ?? null,
        workProductContentType: effectiveWorkProductForChat.workProductContentType ?? null,
        workProductPhase: effectiveWorkProductForChat.workProductPhase ?? null,
        editorSurface: effectiveWorkProductForChat.editorSurface ?? null,
        featureId: effectiveWorkProductForChat.featureId ?? null,
        featureName: effectiveWorkProductForChat.featureName ?? null,
        userStoryId: effectiveWorkProductForChat.userStoryId ?? null,
        userStoryTitle: effectiveWorkProductForChat.userStoryTitle ?? null
    };
}

export function deriveActiveWorkProductForChat(
    currentView: string,
    effectiveWorkProductForChat: Partial<ChatWorkProductScope> | null | undefined
): ChatWorkProductScope | null {
    if (currentView !== "editor") return null;
    return normalizeActiveWorkProductForChat(effectiveWorkProductForChat);
}
